"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ALERT_MESSAGES = {
  deleted: 'Your reviews were successfully deleted.',
  retired: 'Your reviews were retired and will not be due for review anymore.',
  restored: 'Your reviews were restored and will due for review again in the future.',
  reset: 'Your reviews were reset and are due now.'
};
var BulkEditReviewsWrapper = function BulkEditReviewsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showSpinner", _descriptor, _this);
      _initializerDefineProperty(_this, "alertMessage", _descriptor2, _this);
      _initializerDefineProperty(_this, "showDeleteConfirmationModal", _descriptor3, _this);
      _initializerDefineProperty(_this, "showResetConfirmationModal", _descriptor4, _this);
      _initializerDefineProperty(_this, "showDeckSelector", _descriptor5, _this);
      _initializerDefineProperty(_this, "showCardTypeSelector", _descriptor6, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "toggleDeleteModal",
      value: function toggleDeleteModal() {
        this.showDeleteConfirmationModal = !this.showDeleteConfirmationModal;
      }
    }, {
      key: "toggleResetModal",
      value: function toggleResetModal() {
        this.showResetConfirmationModal = !this.showResetConfirmationModal;
      }
    }, {
      key: "destroyReviews",
      value: function destroyReviews() {
        this.showSpinner = true;
        this.showDeleteConfirmationModal = false;
        _state.DeckUI.cardStore.batchDestroy({
          data: {
            cardIds: this.props.selectedReviewIds
          }
        }, this.afterDestroyReviews);
      }
    }, {
      key: "afterDestroyReviews",
      value: function afterDestroyReviews() {
        var _this2 = this;
        this.showSpinner = false;
        this.alertMessage = ALERT_MESSAGES['deleted'];
        (0, _lodash.remove)(_state.DeckUI.cardStore.indexData, function (item) {
          return _this2.props.selectedReviewIds.indexOf(item.id) !== -1;
        });
        this.props.resetSelectedCards();
        setTimeout(function () {
          _this2.alertMessage = null;
        }, 3000);
        this.props.afterChange();
      }
    }, {
      key: "nonRetiredSelectedCards",
      get: function get() {
        var _this$selectedCards;
        return (_this$selectedCards = this.selectedCards) === null || _this$selectedCards === void 0 ? void 0 : _this$selectedCards.filter(function (item) {
          return !item.retired;
        });
      }
    }, {
      key: "resetReviews",
      value: function resetReviews() {
        this.showResetConfirmationModal = false;
        if (this.selectedCards.length === 0) {
          return;
        }
        this.selectedCards.forEach(function (card) {
          return card.onResetReview();
        });
        _state.DeckUI.cardStore.batchReset({
          data: {
            cardIds: this.props.selectedReviewIds
          }
        }, this.afterResetReviews);
      }
    }, {
      key: "retireReviews",
      value: function retireReviews() {
        var _this$selectedCards2,
          _this3 = this;
        var retired = this.nonRetiredSelectedCards.length !== 0;
        (_this$selectedCards2 = this.selectedCards) === null || _this$selectedCards2 === void 0 || _this$selectedCards2.forEach(function (item) {
          return item.set('retired', retired);
        });
        _state.DeckUI.cardStore.batchUpdate({
          data: {
            cardIds: this.props.selectedReviewIds,
            retired: retired
          }
        }, function () {
          return _this3.afterRetireReviews(retired);
        });
      }
    }, {
      key: "updateSelectedCardsDeck",
      value: function updateSelectedCardsDeck(deckId) {
        var _this$selectedCards3;
        if (!_state.AppUI.layout.isNative) {
          this.showDeckSelector = false;
        }
        (_this$selectedCards3 = this.selectedCards) === null || _this$selectedCards3 === void 0 || _this$selectedCards3.forEach(function (item) {
          return item.set('deckId', deckId);
        });
        _state.DeckUI.cardStore.batchUpdate({
          data: {
            cardIds: this.props.selectedReviewIds,
            deckId: deckId
          }
        }, this.afterUpdateDeck.bind(this, deckId));
      }
    }, {
      key: "updateSelectedCardsType",
      value: function updateSelectedCardsType(cardTypeId) {
        var _this$selectedCards4;
        if (!_state.AppUI.layout.isNative) {
          this.showCardTypeSelector = false;
        }
        (_this$selectedCards4 = this.selectedCards) === null || _this$selectedCards4 === void 0 || _this$selectedCards4.forEach(function (item) {
          return item.set('cardTypeId', cardTypeId);
        });
        _state.DeckUI.cardStore.batchUpdate({
          data: {
            cardIds: this.props.selectedReviewIds,
            cardTypeId: cardTypeId
          }
        }, this.afterUpdateCardTypes.bind(this, cardTypeId));
      }
    }, {
      key: "afterUpdateWithFilters",
      value: function afterUpdateWithFilters() {
        this.showSpinner = false;
        this.props.resetSelectedCards();
      }
    }, {
      key: "afterUpdateCardTypes",
      value: function afterUpdateCardTypes(cardTypeId) {
        if ((0, _src.isPresent)(_state.AppUI.cardStore.getFilterValue('card_type_id')) && !_state.AppUI.cardStore.getFilterValue('card_type_id').includes(cardTypeId)) {
          this.showSpinner = true;
          this.props.afterChange(this.afterUpdateWithFilters);
        }
      }
    }, {
      key: "afterUpdateDeck",
      value: function afterUpdateDeck(deckId) {
        if ((0, _src.isPresent)(_state.AppUI.cardStore.getFilterValue('deck_id')) && !_state.AppUI.cardStore.getFilterValue('deck_id').includes(deckId)) {
          this.showSpinner = true;
          this.props.afterChange(this.afterUpdateWithFilters);
        }
      }
    }, {
      key: "afterRetireReviews",
      value: function afterRetireReviews(retired) {
        var _this4 = this;
        this.alertMessage = ALERT_MESSAGES[retired ? 'retired' : 'restored'];
        setTimeout(function () {
          _this4.alertMessage = null;
        }, 4000);
      }
    }, {
      key: "afterResetReviews",
      value: function afterResetReviews() {
        var _this5 = this;
        this.alertMessage = ALERT_MESSAGES['reset'];
        setTimeout(function () {
          _this5.alertMessage = null;
        }, 4000);
        if ((0, _src.isPresent)(_state.AppUI.cardStore.getFilterValue('due')) || _state.AppUI.cardStore.sort.includes('review_after')) {
          this.showSpinner = true;
          this.props.afterChange(this.afterUpdateWithFilters);
        }
      }
    }, {
      key: "afterUpdateReviews",
      value: function afterUpdateReviews() {
        this.showSpinner = false;
      }
    }, {
      key: "selectedCards",
      get: function get() {
        var _this6 = this;
        return _state.DeckUI.cardStore.indexData.filter(function (item) {
          return _this6.props.selectedReviewIds.indexOf(item.id) !== -1;
        });
      }
    }, {
      key: "deckId",
      get: function get() {
        if ((0, _utils.isBlank)(this.props.selectedReviewIds)) {
          return null;
        }
        var cardIds = (0, _lodash.uniq)(this.selectedCards.map(function (item) {
          return item.deckId;
        }));
        if (cardIds.length === 1) {
          return cardIds[0];
        }
        return null;
      }
    }, {
      key: "toggleShowDeckSelector",
      value: function toggleShowDeckSelector() {
        this.showDeckSelector = !this.showDeckSelector;
        this.showCardTypeSelector = false;
      }
    }, {
      key: "toggleShowCardTypeSelector",
      value: function toggleShowCardTypeSelector() {
        this.showCardTypeSelector = !this.showCardTypeSelector;
        this.showDeckSelector = false;
      }
    }, {
      key: "handleOutsideClick",
      value: function handleOutsideClick(event) {
        var selector = document.querySelector('.selector');
        if (selector && !selector.contains(event.target)) {
          this.showDeckSelector = false;
          this.showCardTypeSelector = false;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showSpinner: this.showSpinner,
          destroyReviews: this.destroyReviews,
          retireReviews: this.retireReviews,
          nonRetiredSelectedCards: this.nonRetiredSelectedCards,
          deckId: this.deckId,
          selectedCards: this.selectedCards,
          updateSelectedCardsDeck: this.updateSelectedCardsDeck,
          updateSelectedCardsType: this.updateSelectedCardsType,
          alertMessage: this.alertMessage,
          showDeckSelector: this.showDeckSelector,
          showCardTypeSelector: this.showCardTypeSelector,
          toggleShowDeckSelector: this.toggleShowDeckSelector,
          toggleShowCardTypeSelector: this.toggleShowCardTypeSelector,
          showDeleteConfirmationModal: this.showDeleteConfirmationModal,
          toggleDeleteModal: this.toggleDeleteModal,
          showResetConfirmationModal: this.showResetConfirmationModal,
          toggleResetModal: this.toggleResetModal,
          handleOutsideClick: this.handleOutsideClick,
          resetReviews: this.resetReviews
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "alertMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "showDeleteConfirmationModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showResetConfirmationModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "showDeckSelector", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showCardTypeSelector", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "toggleDeleteModal", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleDeleteModal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleResetModal", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleResetModal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "destroyReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "destroyReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterDestroyReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterDestroyReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nonRetiredSelectedCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nonRetiredSelectedCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "resetReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "resetReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "retireReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "retireReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateSelectedCardsDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateSelectedCardsDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateSelectedCardsType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateSelectedCardsType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdateWithFilters", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdateWithFilters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdateCardTypes", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdateCardTypes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdateDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdateDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterRetireReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterRetireReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterResetReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterResetReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdateReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdateReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleShowDeckSelector", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleShowDeckSelector"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleShowCardTypeSelector", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleShowCardTypeSelector"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleOutsideClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleOutsideClick"), _class2.prototype), _class2)) || _class;
};
BulkEditReviewsWrapper.displayName = 'BulkEditReviewsWrapper';
var _default = exports["default"] = BulkEditReviewsWrapper;